module.exports = __webpack_public_path__ + "static/media/Logo blackswan  (1).485fdc89.png";